import React from 'react';
import { Typography, Grid, Box } from '@material-ui/core';
import LabelTitle from '../../../../../components/Titles/LabelTitle';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../components/Buttons';
import { StyledMessageButton, Title, StyledLink, StyledLinkBox } from '../styles';
import Animation from '../../../../../components/Animation';

const Promo = props => {
	const { t } = useTranslation();
	return (
		<Grid item xs={12} md={6} className="data-grid">
			<Animation animateIn="fadeInLeft">
				<LabelTitle content={t('general.inscriptions.label')} />
				<Title variant="h1" color="textPrimary">
					{t('general.inscriptions.title')}
				</Title>
			</Animation>
			<Grid container spacing={1} className="promo-grid">
				<Grid item xs={12}>
					<Typography variant="h6" color="textPrimary">
						Get the beta module 5 "Congenital Heart Disease" for only €150!
					</Typography>
				</Grid>
				<Grid item xs={4} sm={3}>
					<Box height="100%" display="flex" alignItems="center">
						<Button
							onClick={() => window.open('/cursos/en/users/sign_up')}
							content={'Get it now'}
							variant={'contained'}
							color={'primary'}
						/>
					</Box>
				</Grid>
				<Grid item xs={8} sm={9}>
					<Typography variant="body1" color="textPrimary">
						In addition, you will receive a 50% discount for the entire course.
					</Typography>
				</Grid>
			</Grid>
			<Typography variant="h6" color="textPrimary">
				Course Attributes
			</Typography>
			<Grid
				container
				spacing={2}
				justify="center"
				alignItems="center"
				className="attributes-grid"
			>
				<Grid item xs={5} sm={6}>
					<Typography
						variant="body1"
						variantMapping={{ body1: 'span' }}
						color="textPrimary"
						className="attribute-item"
					>
						✓ Accessible video library
					</Typography>
				</Grid>
				<Grid item xs={5} sm={6}>
					<Typography
						variant="body1"
						variantMapping={{ body1: 'span' }}
						color="textPrimary"
						className="attribute-item"
					>
						✓ Unique, Handy & Useful
					</Typography>
				</Grid>
				<Grid item xs={5} sm={6}>
					<Typography
						variant="body1"
						variantMapping={{ body1: 'span' }}
						color="textPrimary"
						classes="attribute-item"
					>
						✓ Improve your diagnostic skills
					</Typography>
				</Grid>
				<Grid item xs={5} sm={6}>
					<Typography
						variant="body1"
						variantMapping={{ body1: 'span' }}
						color="textPrimary"
					>
						✓ Interaction with the video
					</Typography>
				</Grid>
			</Grid>
			<StyledLinkBox my={2}>
				<StyledLink onClick={props.scrollToDirectorMessage}>
					Course details explained by Eduard Gratacós. Find out more in the next
					video
				</StyledLink>
			</StyledLinkBox>
			<Box display={{ xs: 'none', md: 'inline' }}>
				<StyledMessageButton
					content={t('general.actions.message')}
					variant={'outlined'}
					color={'primary'}
					onClick={props.scrollToDirectorMessage}
				/>
			</Box>
		</Grid>
	);
};

export default Promo;
